// React
import { useEffect, useState } from 'react'

// Mantine
import { Button } from '@mantine/core'

// Icons
import { Plus } from '@untitled-ui/icons-react'

// Custom
import RouterLink from '@/components/ui/RouterLink'

// UI
import PurchaseOrdersTable from '@/components/purchase_orders/PurchaseOrdersTable'
import Breadcrumbs from '@/components/ui/Breadcrumbs'

export default function IndexPurchaseOrders() {
    const rightSection = (
        <Button href="/purchase_orders/create" component={RouterLink} variant="light" color="dark" leftSection={<Plus width={14} height={14} />}>
            Créer un bon de commande
        </Button>
    )

    const layoutProps = {
        breadcrumbs: [
            {
                label: 'Bons de commande',
            },
        ],
        rightSection,
    }

    return (
        <div>
            <Breadcrumbs {...layoutProps} />
            <PurchaseOrdersTable />
        </div>
    )
}
